import classNames from 'classnames';
import { FC, memo } from 'react';
import { IPageItem } from '../../types';
import './style.scss';

interface IProps extends IPageItem {
  lastPage: number;
  changePage: (value: number) => void;
}

const PaginationButton: FC<IProps> = ({ value, label, isActive, lastPage, changePage }: IProps): JSX.Element | null => {
  const buttonClassName: string = classNames('pagination__button', { pagination__button_active: isActive });

  if (value < 1 || value > lastPage) return null;

  return (
    <button className={buttonClassName} onClick={() => changePage(value)}>
      {label || value}
    </button>
  );
};

export default memo(PaginationButton);
